const translations = {
  en: {
    // Nav
    brand: 'Atelier AI',
    navSettings: 'Settings',
    navGenerate: 'Generate',
    navDressGenerate: 'Dress Generate',
    navExplorer: 'Explorer',
    navGallery: 'Gallery',
    navLogout: 'Logout',
    navLogin: 'Login',
    navDarkMode: 'Dark Mode',
    navLightMode: 'Light Mode',

    // Auth
    login: 'Login',
    register: 'Register',
    loginSubtitle: 'Sign in to your account',
    registerSubtitle: 'Create a new account',
    email: 'Email',
    password: 'Password',
    fullName: 'Full Name',
    loggingIn: 'Signing in...',
    registering: 'Creating account...',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    passwordHint: 'Min 6 chars, uppercase, lowercase, digit, special char',

    // Settings Page
    settingsTitle: 'Settings',
    settingsSubtitle: 'Configure your API key, prompt, style images, and generation options',
    apiKeyLabel: 'OpenAI API Key',
    apiKeyPlaceholder: 'sk-...',
    promptLabel: 'Prompt Text',
    promptPlaceholder: 'Transfer the style from the style image to the source image...',
    sizeLabel: 'Size',
    sizeSquare: '1024×1024 (Square)',
    sizeLandscape: '1536×1024 (Landscape)',
    sizePortrait: '1024×1536 (Portrait)',
    sizeAuto: 'Auto',
    qualityLabel: 'Quality',
    qualityHigh: 'High',
    qualityMedium: 'Medium',
    qualityLow: 'Low',
    fontLabel: 'Font',
    fontSizeLabel: 'Font Size',
    saving: 'Saving...',
    saveBtn: 'Save Settings',
    savedMsg: 'Settings saved successfully!',
    styleImagesLabel: 'Style Images (Image 2)',
    styleImagesCount: (count) => `${count} image${count !== 1 ? 's' : ''} — click to set as default`,
    uploading: 'Uploading...',
    uploadBtn: 'Upload',
    noStyleImages: 'No style images yet — click to upload',
    styleUploaded: 'Style image uploaded!',
    defaultUpdated: 'Default style image updated!',
    styleDeleted: 'Style image deleted',
    deleteConfirmStyle: 'Delete this style image?',
    defaultBadge: 'Default',

    // Generate Page
    generateTitle: 'Generate Styled Outfit',
    generateSubtitle: 'Upload your source image and click Generate',
    sourceImageLabel: 'Source Image',
    uploadSourceText: 'Click to upload source content image',
    generating: 'Generating... (this may take a moment)',
    generateBtn: 'Generate',
    colorChangeLabel: 'Change Color',
    noChange: 'No Change (Keep Original)',
    detectedDressType: 'Detected Dress Type',
    onePiece: 'One Piece',
    twoPiece: 'Two Pieces',
    mainColor: 'Main Color',
    topColor: 'Top Color',
    bottomColor: 'Bottom Color',
    regenerateWithColor: 'Regenerate with New Colors',
    uploadFirst: 'Please upload a source image first.',
    generatingLoader: 'Generating styled image and detecting outfit details...',
    generatedImageTitle: 'Generated Image',
    outfitDetailsTitle: 'Outfit Design Details',

    // Dress Generate Page
    dressTitle: 'Dress Generate',
    dressSubtitle: 'Select dress details below and generate your custom design',
    tabDress: 'Dress Options',
    tabEmbroidery: 'Embroidery',
    tabAccessories: 'Accessories',
    selectPlaceholder: (label) => `Select ${label.toLowerCase()}...`,
    embroideryTypeLabel: 'Embroidery Type',
    embroideryPosLabel: 'Embroidery Position(s)',
    embroideryPosHint: 'Select one or more areas where embroidery will be applied',
    generatingDress: 'Generating... (this may take a moment)',
    generateDressBtn: 'Generate Dress',
    selectAllFirst: 'Please select all dress options before generating.',
    selectEmbroideryPos: 'Please select at least one embroidery position.',
    generatingDressLoader: 'Generating your custom dress design...',
    generatedDressTitle: 'Generated Dress',
    dressDetailsTitle: 'Dress Design Details',

    // Explorer Page
    explorerTitle: 'Explorer',
    explorerSubtitle: 'Browse all generated outfit designs',
    filterRandom: 'Random',
    filterLatest: 'Latest',
    filterMostLiked: 'Most Liked',
    filterMostViewed: 'Most Viewed',
    loadingImages: 'Loading images...',
    loadFailed: 'Failed to load images.',
    deleteFailed: 'Failed to delete.',
    deleteConfirmOutfit: 'Delete this outfit design?',
    noImages: 'No generated images yet. Go to Generate to create your first outfit!',

    // Subscription & Credits
    subscriptionFree: 'Free',
    subscriptionPremium: 'Premium',
    subscriptionPremiumPlus: 'Premium+',
    credits: 'Credits',
    creditsRemaining: 'credits remaining',
    freeLimit: 'Free limit',
    freeLimitReached: 'Free plan limit reached. Upgrade to Premium for more.',
    insufficientCredits: 'Insufficient credits. You need 2 credits per generation.',
    costPerGeneration: '2 credits per generation',
    visibility: 'Visibility',
    visibilityPublic: 'Public',
    visibilityPrivate: 'Private',
    visibilityChanged: 'Visibility updated',
    onlyPremiumPlus: 'Premium+ feature',
    upgradeForMore: 'Upgrade for more generations',
    generationsUsed: 'used',
    of: 'of',

    // Gallery Page
    galleryTitle: 'My Gallery',
    gallerySubtitle: 'Your designs and liked outfits in one place',
    galleryMyDesigns: 'My Designs',
    galleryLiked: 'Liked',
    galleryNoDesigns: 'You haven\'t generated any designs yet. Head to Dress Generate to create your first!',
    galleryNoLiked: 'You haven\'t liked any designs yet. Explore and find outfits you love!',

    // Field Options Page
    navFieldOptions: 'Field Options',
    fieldOptionsTitle: 'Field Options Manager',
    fieldOptionsSubtitle: 'Add or remove dropdown options for the Dress Generate page',
    fieldSelectLabel: 'Select Field',
    fieldOptionsLoading: 'Loading options...',
    fieldOptionsLoadFailed: 'Failed to load options.',
    fieldOptionsEmpty: 'No options for this field yet. Add the first one below!',
    fieldAddValue: 'Value (sent to API)',
    fieldAddLabelEn: 'Label (English)',
    fieldAddLabelAr: 'Label (Arabic)',
    fieldAddGroupEn: 'Group EN (embroidery only)',
    fieldAddGroupAr: 'Group AR (embroidery only)',
    fieldAddBtn: 'Add Option',
    fieldDeleteConfirm: 'Delete this option?',
    fieldSaving: 'Saving...',
    fieldNames: {
      silhouette: 'Silhouette', fabric: 'Fabric', color: 'Color', neckline: 'Neckline',
      sleeve: 'Sleeve', sleeveStyle: 'Sleeve Style', bodice: 'Bodice', waist: 'Waist', length: 'Length',
      skirtDetail: 'Skirt Detail', slitType: 'Slit Type', hem: 'Hem',
      embroideryType: 'Embroidery Type', embroideryPosition: 'Embroidery Position',
    },

    // Detail Fields
    silhouette: 'Silhouette',
    color: 'Color',
    neckline: 'Neckline',
    sleeves: 'Sleeves',
    sleeveStyle: 'Sleeve Style',
    length: 'Length',
    bodice: 'Bodice',
    waist: 'Waist',
    fabric: 'Fabric',
    skirtDetail: 'Skirt Detail',
    slit: 'Slit',
    hem: 'Hem',
    embroidery: 'Embroidery',
    embroideryPosition: 'Embroidery Position',
    hairstyle: 'Hairstyle',
    shoes: 'Shoes',
    jewelry: 'Jewelry',
    belt: 'Belt',
    sunglasses: 'Sunglasses',
    hat: 'Hat',
    bag: 'Bag',

    // Dress Options — { value: sent to API, label: shown in dropdown }
    dressOptions: {
      silhouette: [
        { value: 'A-Line', label: 'A-Line' },
        { value: 'Mermaid', label: 'Mermaid' },
        { value: 'Ball Gown', label: 'Ball Gown' },
        { value: 'Sheath', label: 'Sheath' },
        { value: 'Wrap', label: 'Wrap' },
        { value: 'Bodycon', label: 'Bodycon' },
      ],
      fabric: [
        { value: 'Silk', label: 'Silk' },
        { value: 'Satin', label: 'Satin' },
        { value: 'Chiffon', label: 'Chiffon' },
        { value: 'Lace', label: 'Lace' },
        { value: 'Velvet', label: 'Velvet' },
        { value: 'Denim', label: 'Denim' },
        { value: 'Cotton', label: 'Cotton' },
        { value: 'Polyester', label: 'Polyester' },
      ],
      color: [
        { value: 'White', label: 'White' },
        { value: 'Ivory', label: 'Ivory' },
        { value: 'Blush Pink', label: 'Blush Pink' },
        { value: 'Champagne', label: 'Champagne' },
        { value: 'Maroon', label: 'Maroon' },
        { value: 'Crimson', label: 'Crimson' },
        { value: 'Navy', label: 'Navy' },
        { value: 'Olive', label: 'Olive' },
        { value: 'Purple', label: 'Purple' },
        { value: 'Emerald', label: 'Emerald' },
      ],
      neckline: [
        { value: 'V-Neck', label: 'V-Neck' },
        { value: 'Sweetheart', label: 'Sweetheart' },
        { value: 'Off-Shoulder', label: 'Off-Shoulder' },
        { value: 'High Neck', label: 'High Neck' },
        { value: 'Scoop', label: 'Scoop' },
        { value: 'Crew', label: 'Crew' },
        { value: 'Square', label: 'Square' },
        { value: 'Boat', label: 'Boat' },
        { value: 'Halter', label: 'Halter' },
        { value: 'Turtleneck', label: 'Turtleneck' },
        { value: 'Keyhole', label: 'Keyhole' },
        { value: 'Strapless', label: 'Strapless' },
        { value: 'Wrap', label: 'Wrap' },
        { value: 'Surplice', label: 'Surplice' },
      ],
      sleeve: [
        { value: 'Sleeveless', label: 'Sleeveless' },
        { value: 'Long Sleeve', label: 'Long Sleeve' },
        { value: 'Cap Sleeve', label: 'Cap Sleeve' },
        { value: 'Three-Quarter', label: 'Three-Quarter' },
      ],
      sleeveStyle: [
        { value: 'None', label: 'None' },
        { value: 'rolled-up sleeves', label: 'Rolled-Up Sleeves' },
        { value: 'straight sleeves', label: 'Straight Sleeves' },
        { value: 'puff sleeves', label: 'Puff Sleeves' },
        { value: 'cuffed sleeves', label: 'Cuffed Sleeves' },
      ],
      bodice: [
        { value: 'Fitted', label: 'Fitted' },
        { value: 'Corset', label: 'Corset' },
        { value: 'Draped', label: 'Draped' },
        { value: 'Embroidered', label: 'Embroidered' },
        { value: 'Asymmetrical', label: 'Asymmetrical' },
        { value: 'Ruched', label: 'Ruched' },
        { value: 'Normal', label: 'Normal' },
      ],
      waist: [
        { value: 'Natural', label: 'Natural' },
        { value: 'Empire', label: 'Empire' },
        { value: 'Drop Waist', label: 'Drop Waist' },
        { value: 'Belted', label: 'Belted' },
        { value: 'Asymmetrical', label: 'Asymmetrical' },
        { value: 'Ruched', label: 'Ruched' },
        { value: 'Basque', label: 'Basque' },
      ],
      length: [
        { value: 'Floor-Length', label: 'Floor-Length' },
        { value: 'Tea-Length', label: 'Tea-Length' },
        { value: 'Knee-Length', label: 'Knee-Length' },
        { value: 'Midi', label: 'Midi' },
      ],
      skirtDetail: [
        { value: 'None', label: 'None' },
        { value: 'Cascading Ruffle', label: 'Cascading Ruffle' },
        { value: 'Asymmetrical Buttons', label: 'Asymmetrical Buttons' },
        { value: 'Fully Ruched', label: 'Fully Ruched' },
      ],
      slitType: [
        { value: 'None', label: 'None' },
        { value: 'Side Slit', label: 'Side Slit' },
        { value: 'Front Slit', label: 'Front Slit' },
        { value: 'Back Slit', label: 'Back Slit' },
      ],
      hem: [
        { value: 'None', label: 'None' },
        { value: 'Embroidered Hem', label: 'Embroidered Hem' },
        { value: 'Handkerchief Hem', label: 'Handkerchief Hem' },
        { value: 'Scalloped Hem', label: 'Scalloped Hem' },
        { value: 'Asymmetrical Hem', label: 'Asymmetrical Hem' },
        { value: 'High-Low Hem', label: 'High-Low Hem' },
      ],
    },

    // Embroidery Types
    embroideryTypes: [
      { value: 'None', label: 'None' },
      { value: 'Flat embroidery (fill stitch / satin stitch)', label: 'Flat embroidery (fill stitch / satin stitch)' },
      { value: '3D / Puff embroidery', label: '3D / Puff embroidery' },
      { value: 'Appliqué embroidery', label: 'Appliqué embroidery' },
      { value: 'Chain stitch embroidery', label: 'Chain stitch embroidery' },
      { value: 'Cross-stitch embroidery', label: 'Cross-stitch embroidery' },
      { value: 'Embroidery patches', label: 'Embroidery patches' },
      { value: 'Sequin embroidery', label: 'Sequin embroidery' },
      { value: 'Bead embroidery', label: 'Bead embroidery' },
      { value: 'Chenille embroidery', label: 'Chenille embroidery' },
      { value: 'Walk stitch embroidery', label: 'Walk stitch embroidery' },
      { value: 'Surface embroidery', label: 'Surface embroidery' },
    ],

    // Embroidery Positions
    embroideryPositionGroups: [
      { group: 'Neckline Area', positions: [
        { value: 'Around the neckline', label: 'Around the neckline' },
        { value: 'Collar edges', label: 'Collar edges' },
      ]},
      { group: 'Bodice', positions: [
        { value: 'Center front panel', label: 'Center front panel' },
        { value: 'Side panels', label: 'Side panels' },
        { value: 'Bust area', label: 'Bust area' },
        { value: 'Waistline band', label: 'Waistline band' },
      ]},
      { group: 'Sleeves', positions: [
        { value: 'Cuffs', label: 'Cuffs' },
        { value: 'Upper sleeve (shoulder area)', label: 'Upper sleeve (shoulder area)' },
        { value: 'Full sleeve motifs', label: 'Full sleeve motifs' },
        { value: 'Sleeve hems', label: 'Sleeve hems' },
      ]},
      { group: 'Skirt', positions: [
        { value: 'Hemline border', label: 'Hemline border' },
        { value: 'Skirt side panels', label: 'Skirt side panels' },
        { value: 'Front slit area', label: 'Front slit area' },
        { value: 'All-over scattered motifs', label: 'All-over scattered motifs' },
      ]},
      { group: 'Overall', positions: [
        { value: 'Full-body embroidery', label: 'Full-body embroidery' },
      ]},
    ],

    // Admin Users Page
    navAdminUsers: 'Manage Users',
    adminUsersTitle: 'User Management',
    adminUsersSubtitle: 'Manage user accounts, credits, subscriptions, and roles',
    adminUserName: 'Name',
    adminUserEmail: 'Email',
    adminUserRole: 'Role',
    adminUserCredits: 'Credits',
    adminUserSubscription: 'Subscription',
    adminUserImages: 'Images',
    adminUserStatus: 'Status',
    adminUserActions: 'Actions',
    adminAddCredits: 'Add Credits',
    adminSuspend: 'Suspend',
    adminUnsuspend: 'Unsuspend',
    adminDelete: 'Delete',
    adminActive: 'Active',
    adminSuspended: 'Suspended',
    adminConfirmDelete: 'Are you sure you want to delete this user? This will also delete all their designs and likes.',
    adminConfirmSuspend: 'Are you sure you want to suspend this user?',
    adminConfirmUnsuspend: 'Are you sure you want to unsuspend this user?',
    adminNoUsers: 'No users found.',
    adminSearchPlaceholder: 'Search by name or email...',
  },

  ar: {
    // Nav
    brand: 'Atelier AI',
    navSettings: 'الاعدادات',
    navGenerate: 'توليد',
    navDressGenerate: 'توليد فستان',
    navExplorer: 'المعرض',
    navGallery: 'معرضي',
    navLogout: 'تسجيل الخروج',
    navLogin: 'تسجيل الدخول',
    navDarkMode: 'الوضع الداكن',
    navLightMode: 'الوضع الفاتح',

    // Auth
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    loginSubtitle: 'قم بتسجيل الدخول إلى حسابك',
    registerSubtitle: 'أنشئ حساباً جديداً',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    fullName: 'الاسم الكامل',
    loggingIn: 'جاري تسجيل الدخول...',
    registering: 'جاري إنشاء الحساب...',
    noAccount: 'ليس لديك حساب؟',
    haveAccount: 'لديك حساب بالفعل؟',
    passwordHint: '٦ أحرف على الأقل، حرف كبير، حرف صغير، رقم، رمز خاص',

    // Settings Page
    settingsTitle: 'الاعدادات',
    settingsSubtitle: 'اعداد مفتاح API والنص التوجيهي وصور الأنماط وخيارات التوليد',
    apiKeyLabel: 'مفتاح OpenAI API',
    apiKeyPlaceholder: 'sk-...',
    promptLabel: 'النص التوجيهي',
    promptPlaceholder: 'انقل النمط من صورة النمط إلى الصورة المصدر...',
    sizeLabel: 'الحجم',
    sizeSquare: '1024×1024 (مربع)',
    sizeLandscape: '1536×1024 (أفقي)',
    sizePortrait: '1024×1536 (عمودي)',
    sizeAuto: 'تلقائي',
    qualityLabel: 'الجودة',
    qualityHigh: 'عالية',
    qualityMedium: 'متوسطة',
    qualityLow: 'منخفضة',
    fontLabel: 'الخط',
    fontSizeLabel: 'حجم الخط',
    saving: 'جاري الحفظ...',
    saveBtn: 'حفظ الاعدادات',
    savedMsg: 'تم حفظ الاعدادات بنجاح!',
    styleImagesLabel: 'صور الأنماط (الصورة 2)',
    styleImagesCount: (count) => `${count} صورة — اضغط لتعيين كافتراضي`,
    uploading: 'جاري الرفع...',
    uploadBtn: 'رفع',
    noStyleImages: 'لا توجد صور أنماط بعد — اضغط للرفع',
    styleUploaded: 'تم رفع صورة النمط!',
    defaultUpdated: 'تم تحديث صورة النمط الافتراضية!',
    styleDeleted: 'تم حذف صورة النمط',
    deleteConfirmStyle: 'هل تريد حذف صورة النمط؟',
    defaultBadge: 'افتراضي',

    // Generate Page
    generateTitle: 'توليد زي بنمط',
    generateSubtitle: 'ارفع الصورة المصدر واضغط توليد',
    sourceImageLabel: 'الصورة المصدر',
    uploadSourceText: 'اضغط لرفع صورة المحتوى المصدر',
    generating: 'جاري التوليد... (قد يستغرق لحظة)',
    generateBtn: 'توليد',
    colorChangeLabel: 'تغيير اللون',
    noChange: 'بدون تغيير (الأصلي)',
    detectedDressType: 'نوع الفستان المكتشف',
    onePiece: 'قطعة واحدة',
    twoPiece: 'قطعتين',
    mainColor: 'اللون الرئيسي',
    topColor: 'لون القطعة العلوية',
    bottomColor: 'لون القطعة السفلية',
    regenerateWithColor: 'إعادة التوليد بألوان جديدة',
    generatingLoader: 'جاري توليد الصورة بالنمط واكتشاف تفاصيل الزي...',
    generatedImageTitle: 'الصورة المولدة',
    outfitDetailsTitle: 'تفاصيل تصميم الزي',

    // Dress Generate Page
    dressTitle: 'توليد فستان',
    dressSubtitle: 'اختر تفاصيل الفستان أدناه وقم بتوليد تصميمك المخصص',
    tabDress: 'خيارات الفستان',
    tabEmbroidery: 'التطريز',
    tabAccessories: 'الإكسسوارات',
    selectPlaceholder: (label) => `اختر ${label}...`,
    embroideryTypeLabel: 'نوع التطريز',
    embroideryPosLabel: 'موقع التطريز',
    embroideryPosHint: 'اختر منطقة واحدة أو أكثر لتطبيق التطريز',
    generatingDress: 'جاري التوليد... (قد يستغرق لحظة)',
    generateDressBtn: 'توليد الفستان',
    selectAllFirst: 'يرجى اختيار جميع خيارات الفستان قبل التوليد.',
    selectEmbroideryPos: 'يرجى اختيار موقع تطريز واحد على الأقل.',
    generatingDressLoader: 'جاري توليد تصميم الفستان المخصص...',
    generatedDressTitle: 'الفستان المولد',
    dressDetailsTitle: 'تفاصيل تصميم الفستان',

    // Explorer Page
    explorerTitle: 'المعرض',
    explorerSubtitle: 'تصفح جميع تصاميم الأزياء المولدة',
    filterRandom: 'عشوائي',
    filterLatest: 'الأحدث',
    filterMostLiked: 'الأكثر إعجاباً',
    filterMostViewed: 'الأكثر مشاهدة',
    loadingImages: 'جاري تحميل الصور...',
    loadFailed: 'فشل تحميل الصور.',
    deleteFailed: 'فشل الحذف.',
    deleteConfirmOutfit: 'هل تريد حذف تصميم الزي؟',
    noImages: 'لا توجد صور مولدة بعد. اذهب إلى التوليد لإنشاء أول زي!',

    // Subscription & Credits
    subscriptionFree: 'مجاني',
    subscriptionPremium: 'مميز',
    subscriptionPremiumPlus: 'مميز+',
    credits: 'رصيد',
    creditsRemaining: 'رصيد متبقي',
    freeLimit: 'حد مجاني',
    freeLimitReached: 'تم الوصول لحد الخطة المجانية. قم بالترقية للمزيد.',
    insufficientCredits: 'رصيد غير كافٍ. تحتاج 2 رصيد لكل توليد.',
    costPerGeneration: '2 رصيد لكل توليد',
    visibility: 'الظهور',
    visibilityPublic: 'عام',
    visibilityPrivate: 'خاص',
    visibilityChanged: 'تم تحديث الظهور',
    onlyPremiumPlus: 'ميزة مميز+',
    upgradeForMore: 'قم بالترقية لمزيد من التوليدات',
    generationsUsed: 'مستخدم',
    of: 'من',

    // Gallery Page
    galleryTitle: 'معرضي',
    gallerySubtitle: 'تصاميمك والأزياء المفضلة في مكان واحد',
    galleryMyDesigns: 'تصاميمي',
    galleryLiked: 'المفضلة',
    galleryNoDesigns: 'لم تقم بإنشاء أي تصاميم بعد. اذهب إلى توليد فستان لإنشاء أول تصميم!',
    galleryNoLiked: 'لم تعجبك أي تصاميم بعد. استكشف وابحث عن أزياء تحبها!',

    // Field Options Page
    navFieldOptions: 'خيارات الحقول',
    fieldOptionsTitle: 'إدارة خيارات الحقول',
    fieldOptionsSubtitle: 'إضافة أو إزالة خيارات القوائم لصفحة توليد الفستان',
    fieldSelectLabel: 'اختر الحقل',
    fieldOptionsLoading: 'جاري تحميل الخيارات...',
    fieldOptionsLoadFailed: 'فشل تحميل الخيارات.',
    fieldOptionsEmpty: 'لا توجد خيارات لهذا الحقل بعد. أضف أول خيار أدناه!',
    fieldAddValue: 'القيمة (ترسل للـ API)',
    fieldAddLabelEn: 'التسمية (إنجليزي)',
    fieldAddLabelAr: 'التسمية (عربي)',
    fieldAddGroupEn: 'المجموعة EN (للتطريز فقط)',
    fieldAddGroupAr: 'المجموعة AR (للتطريز فقط)',
    fieldAddBtn: 'إضافة خيار',
    fieldDeleteConfirm: 'هل تريد حذف هذا الخيار؟',
    fieldSaving: 'جاري الحفظ...',
    fieldNames: {
      silhouette: 'القصة', fabric: 'القماش', color: 'اللون', neckline: 'فتحة العنق',
      sleeve: 'الأكمام', sleeveStyle: 'نمط الأكمام', bodice: 'الصدرية', waist: 'الخصر', length: 'الطول',
      skirtDetail: 'تفاصيل التنورة', slitType: 'الشق', hem: 'الحاشية',
      embroideryType: 'نوع التطريز', embroideryPosition: 'موقع التطريز',
    },

    // Detail Fields
    silhouette: 'القصة',
    color: 'اللون',
    neckline: 'فتحة العنق',
    sleeves: 'الأكمام',
    sleeveStyle: 'نمط الأكمام',
    length: 'الطول',
    bodice: 'الصدرية',
    waist: 'الخصر',
    fabric: 'القماش',
    skirtDetail: 'تفاصيل التنورة',
    slit: 'الشق',
    hem: 'الحاشية',
    embroidery: 'التطريز',
    embroideryPosition: 'موقع التطريز',
    hairstyle: 'تسريحة الشعر',
    shoes: 'الأحذية',
    jewelry: 'المجوهرات',
    belt: 'الحزام',
    sunglasses: 'النظارات الشمسية',
    hat: 'القبعة',
    bag: 'الحقيبة',

    // Dress Options
    dressOptions: {
      silhouette: [
        { value: 'A-Line', label: 'إيه لاين' },
        { value: 'Mermaid', label: 'حورية البحر' },
        { value: 'Ball Gown', label: 'فستان سهرة' },
        { value: 'Sheath', label: 'ضيق مستقيم' },
        { value: 'Wrap', label: 'ملفوف' },
        { value: 'Bodycon', label: 'بودي كون' },
      ],
      fabric: [
        { value: 'Silk', label: 'حرير' },
        { value: 'Satin', label: 'ساتان' },
        { value: 'Chiffon', label: 'شيفون' },
        { value: 'Lace', label: 'دانتيل' },
        { value: 'Velvet', label: 'مخمل' },
        { value: 'Denim', label: 'جينز' },
        { value: 'Cotton', label: 'قطن' },
        { value: 'Polyester', label: 'بوليستر' },
      ],
      color: [
        { value: 'White', label: 'أبيض' },
        { value: 'Ivory', label: 'عاجي' },
        { value: 'Blush Pink', label: 'وردي فاتح' },
        { value: 'Champagne', label: 'شامبين' },
        { value: 'Maroon', label: 'كستنائي' },
        { value: 'Crimson', label: 'قرمزي' },
        { value: 'Navy', label: 'كحلي' },
        { value: 'Olive', label: 'زيتي' },
        { value: 'Purple', label: 'بنفسجي' },
        { value: 'Emerald', label: 'زمردي' },
      ],
      neckline: [
        { value: 'V-Neck', label: 'رقبة V' },
        { value: 'Sweetheart', label: 'سويت هارت' },
        { value: 'Off-Shoulder', label: 'أوف شولدر' },
        { value: 'High Neck', label: 'رقبة عالية' },
        { value: 'Scoop', label: 'رقبة دائرية' },
        { value: 'Crew', label: 'رقبة مستديرة' },
        { value: 'Square', label: 'رقبة مربعة' },
        { value: 'Boat', label: 'رقبة قارب' },
        { value: 'Halter', label: 'هالتر' },
        { value: 'Turtleneck', label: 'رقبة عالية مغلقة' },
        { value: 'Keyhole', label: 'فتحة مفتاح' },
        { value: 'Strapless', label: 'بدون أحمال' },
        { value: 'Wrap', label: 'ملفوف' },
        { value: 'Surplice', label: 'سربليس' },
      ],
      sleeve: [
        { value: 'Sleeveless', label: 'بدون أكمام' },
        { value: 'Long Sleeve', label: 'كم طويل' },
        { value: 'Cap Sleeve', label: 'كم قصير' },
        { value: 'Three-Quarter', label: 'كم ثلاثة أرباع' },
      ],
      sleeveStyle: [
        { value: 'None', label: 'بدون' },
        { value: 'rolled-up sleeves', label: 'أكمام ملفوفة' },
        { value: 'straight sleeves', label: 'أكمام مستقيمة' },
        { value: 'puff sleeves', label: 'أكمام منفوخة' },
        { value: 'cuffed sleeves', label: 'أكمام بأساور' },
      ],
      bodice: [
        { value: 'Fitted', label: 'ضيق' },
        { value: 'Corset', label: 'كورسيه' },
        { value: 'Draped', label: 'مطوي' },
        { value: 'Embroidered', label: 'مطرز' },
        { value: 'Asymmetrical', label: 'غير متماثل' },
        { value: 'Ruched', label: 'مكسر' },
        { value: 'Normal', label: 'عادي' },
      ],
      waist: [
        { value: 'Natural', label: 'طبيعي' },
        { value: 'Empire', label: 'إمباير' },
        { value: 'Drop Waist', label: 'خصر منخفض' },
        { value: 'Belted', label: 'بحزام' },
        { value: 'Asymmetrical', label: 'غير متماثل' },
        { value: 'Ruched', label: 'مكسر' },
        { value: 'Basque', label: 'باسك' },
      ],
      length: [
        { value: 'Floor-Length', label: 'طول الأرض' },
        { value: 'Tea-Length', label: 'طول الشاي' },
        { value: 'Knee-Length', label: 'طول الركبة' },
        { value: 'Midi', label: 'ميدي' },
      ],
      skirtDetail: [
        { value: 'None', label: 'بدون' },
        { value: 'Cascading Ruffle', label: 'كشكشة متدرجة' },
        { value: 'Asymmetrical Buttons', label: 'أزرار غير متماثلة' },
        { value: 'Fully Ruched', label: 'مكسر بالكامل' },
      ],
      slitType: [
        { value: 'None', label: 'بدون' },
        { value: 'Side Slit', label: 'شق جانبي' },
        { value: 'Front Slit', label: 'شق أمامي' },
        { value: 'Back Slit', label: 'شق خلفي' },
      ],
      hem: [
        { value: 'None', label: 'بدون' },
        { value: 'Embroidered Hem', label: 'حاشية مطرزة' },
        { value: 'Handkerchief Hem', label: 'حاشية منديل' },
        { value: 'Scalloped Hem', label: 'حاشية صدفية' },
        { value: 'Asymmetrical Hem', label: 'حاشية غير متماثلة' },
        { value: 'High-Low Hem', label: 'حاشية عالية-منخفضة' },
      ],
    },

    // Embroidery Types
    embroideryTypes: [
      { value: 'None', label: 'بدون' },
      { value: 'Flat embroidery (fill stitch / satin stitch)', label: 'تطريز مسطح (غرزة تعبئة / غرزة ساتان)' },
      { value: '3D / Puff embroidery', label: 'تطريز ثلاثي الأبعاد / منتفخ' },
      { value: 'Appliqué embroidery', label: 'تطريز أبليك' },
      { value: 'Chain stitch embroidery', label: 'تطريز غرزة السلسلة' },
      { value: 'Cross-stitch embroidery', label: 'تطريز غرزة متقاطعة' },
      { value: 'Embroidery patches', label: 'رقع تطريز' },
      { value: 'Sequin embroidery', label: 'تطريز ترتر' },
      { value: 'Bead embroidery', label: 'تطريز خرز' },
      { value: 'Chenille embroidery', label: 'تطريز شنيل' },
      { value: 'Walk stitch embroidery', label: 'تطريز غرزة المشي' },
      { value: 'Surface embroidery', label: 'تطريز سطحي' },
    ],

    // Embroidery Positions
    embroideryPositionGroups: [
      { group: 'منطقة العنق', positions: [
        { value: 'Around the neckline', label: 'حول فتحة العنق' },
        { value: 'Collar edges', label: 'أطراف الياقة' },
      ]},
      { group: 'الصدرية', positions: [
        { value: 'Center front panel', label: 'اللوحة الأمامية الوسطى' },
        { value: 'Side panels', label: 'اللوحات الجانبية' },
        { value: 'Bust area', label: 'منطقة الصدر' },
        { value: 'Waistline band', label: 'حزام الخصر' },
      ]},
      { group: 'الأكمام', positions: [
        { value: 'Cuffs', label: 'الأساور' },
        { value: 'Upper sleeve (shoulder area)', label: 'الكم العلوي (منطقة الكتف)' },
        { value: 'Full sleeve motifs', label: 'زخارف الكم الكامل' },
        { value: 'Sleeve hems', label: 'أطراف الأكمام' },
      ]},
      { group: 'التنورة', positions: [
        { value: 'Hemline border', label: 'حافة الذيل' },
        { value: 'Skirt side panels', label: 'لوحات التنورة الجانبية' },
        { value: 'Front slit area', label: 'منطقة الشق الأمامي' },
        { value: 'All-over scattered motifs', label: 'زخارف متناثرة بالكامل' },
      ]},
      { group: 'شامل', positions: [
        { value: 'Full-body embroidery', label: 'تطريز كامل الجسم' },
      ]},
    ],

    // Admin Users Page
    navAdminUsers: 'إدارة المستخدمين',
    adminUsersTitle: 'إدارة المستخدمين',
    adminUsersSubtitle: 'إدارة حسابات المستخدمين والرصيد والاشتراكات والأدوار',
    adminUserName: 'الاسم',
    adminUserEmail: 'البريد الإلكتروني',
    adminUserRole: 'الدور',
    adminUserCredits: 'الرصيد',
    adminUserSubscription: 'الاشتراك',
    adminUserImages: 'الصور',
    adminUserStatus: 'الحالة',
    adminUserActions: 'الإجراءات',
    adminAddCredits: 'إضافة رصيد',
    adminSuspend: 'تعليق',
    adminUnsuspend: 'إلغاء التعليق',
    adminDelete: 'حذف',
    adminActive: 'نشط',
    adminSuspended: 'معلق',
    adminConfirmDelete: 'هل أنت متأكد من حذف هذا المستخدم؟ سيتم حذف جميع تصاميمه وإعجاباته.',
    adminConfirmSuspend: 'هل أنت متأكد من تعليق هذا المستخدم؟',
    adminConfirmUnsuspend: 'هل أنت متأكد من إلغاء تعليق هذا المستخدم؟',
    adminNoUsers: 'لا يوجد مستخدمين.',
    adminSearchPlaceholder: 'بحث بالاسم أو البريد...',
  },
};

export default translations;